import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import { $t } from "@/config/i18n";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

export function replaceUnknownLocation(): void {
  const isUnknown = router
    .resolve(window.location.pathname)
    .matched.some((record) => record.path === "/:pathMatch(.*)*");

  if (isUnknown) {
    window.history.replaceState(window.history.state, "", "/auth/404");
  }
}

router.beforeResolve((to: { hash?: string }) => {
  if (to.hash) {
    return { ...to, hash: "" };
  }
});

router.afterEach((to) => {
  const routeName = to.name;
  if (
    routeName &&
    routeName !== "home" &&
    routeName !== "isAvailable" &&
    routeName !== "externalIdp" &&
    routeName !== "referantialsLoading"
  ) {
    const page = `page_title.${to.name as string}`;
    document.title = `BISOM - ${$t(page)}`;
  } else {
    document.title = "BISOM";
  }
});

export default router;
